import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M3 19h18V5H3v14zM5 7h9v2H5V7zm0 3h9v2H5v-2z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h9v2H5zm0-3h9v2H5z"
})), 'FeaturedPlayListTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FeaturedPlayListTwoTone.js
// module id = 3533
// module chunks = 2